import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, Input, LOCALE_ID, Inject, Output, EventEmitter } from '@angular/core';
import { StyleClassModule } from 'primeng/styleclass';
import { TranslateModule} from '@ngx-translate/core';
import { DrawerModule } from 'primeng/drawer';
import { Observable } from 'rxjs';
import {ClientProfileComponent} from '@fitness-force/client-profile-lib'

@Component({
  selector: 'client-info-sidebar',
  templateUrl: './client-info-sidebar.component.html',
  styleUrls: ['./client-info-sidebar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    StyleClassModule,
    DrawerModule,
    ClientProfileComponent,
    TranslateModule
]
})
export class ClientInfoSidebarComponent implements OnInit {
  @Input() showClientSidebar: boolean = false;
  @Input() activeClientId: number = 0;
  @Input() interactionId: number = 0;
  @Input() activeTab: string = 'overview';
  @Output() closeSidebar: EventEmitter<boolean> = new EventEmitter();

  public companyInfoDetail$!: Observable<any>;

  constructor(@Inject(LOCALE_ID) public locale: string) { }

  ngOnInit(): void {
    
  }

  CloseSidebar() {
    this.showClientSidebar = false;
    this.closeSidebar.emit(this.showClientSidebar);
  }

  closeClientSidebar()
  {
    this.showClientSidebar = false;
    this.closeSidebar.emit(this.showClientSidebar);
  }
}
